import React, { useState, useEffect } from 'react';
import {
  Grid,
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  Autocomplete,
  CircularProgress,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import {
    getemployeesByAirport,
    getallemployeesByAirport,
    getallemployeesByAirportForEdit,
    getProfilesByApplication,
    getApplicationByProfile
} from '../logic';
import Button from '@mui/material/Button';
import Delete from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { ACTIONS } from '../../../../shared/constants';
import { useSnackbar } from 'notistack';
import { getUser } from '../../../../shared/auth-service';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

const ManagementEmployeeDetail = ({
  data,
  handleClose,
  handleSave,
  employeeId,
  employee,
  airports,
  airportId,
  profiles,
  applications,
  action
}) => {
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(employeeId);
  const [selectedCodes, setSelectedCodes] = useState(data?.profiles || []);
  const [selectedCodesSend, setSelectedCodesSend] = useState({
    profiles: [], 
    employeeId: selectedEmployeeId, 
  });
  const [selectedCode, setSelectedCode] = useState(null);
  const [perfilId, setPerfilId] = useState(data?.employeeId.Id || '');
  const [selectedAirport, setSelectedAirport] = useState(airportId);
  const isDataReadOnly = action !== ACTIONS.NEW;
  const [profileValue, setProfileValue] = useState(action === ACTIONS.NEW ? '' : '');
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const [employeeSelected, setEmployeeSelected] = useState(null);
  const [user, setUser] = useState(data != null ? data : []);
  const [userId, setUserId] = useState(data != null ? data.id : 0);
  const [selectedApplicationId, setSelectedApplicationId] = useState('');
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [loadingProfiles, setLoadingProfiles] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [showCancelAlert, setShowCancelAlert] = useState(false);
  const [expandedGroups, setExpandedGroups] = useState(new Set());

  
  const [changes, setChanges] = useState({
    Base: false,
    Picture: false
  });
  const [employees, setEmployees] = useState([]);
  const [employeeValue, setEmployeeValue] = useState(action === ACTIONS.NEW ? '' : employeeId);
  const userData = getUser();
  const companyId = userData.countryCode.split('-')[0];

useEffect(() => {
    const fetchData = async () => {
      setLoadingEmployees(true);
      const employeesData = await loadEmployeesByAirport(selectedAirport);
      setLoadingEmployees(false);

      if (isDataReadOnly) {
        const employeeToSelect = employeesData.find(e => e.employeeId === selectedEmployeeId);
        setEmployeeSelected(employeeToSelect);
      } else {
        setSelectedCodes([]);
      }
    };

    fetchData();
  }, [action, employeeId, selectedAirport]);


useEffect(() => {
  const normalizeProfilesWithApplications = async () => {
    if (isDataReadOnly && data?.profiles?.length > 0) {
      setLoadingProfiles(true); // <-- INICIA CARGA

      const normalized = [];
      const seen = new Set();

      for (const p of data.profiles) {
        if (p.applicationId && p.applicationName) {
          // SP ya devuelve applicationId — usar directamente (evita duplicados)
          const key = `${p.id}-${p.applicationId}`;
          if (!seen.has(key)) {
            seen.add(key);
            normalized.push({
              id: key,
              profileId: p.id,
              description: p.description,
              applicationId: p.applicationId,
              applicationName: p.applicationName,
              applicationIds: [p.applicationId]
            });
          }
        } else {
          // Fallback: SP no actualizado aún
          const apps = await getApplicationByProfile(p.id, companyId);
          if (!apps || apps.length === 0) continue;
          for (const app of apps) {
            const key = `${p.id}-${app.id}`;
            if (!seen.has(key)) {
              seen.add(key);
              normalized.push({
                id: key,
                profileId: p.id,
                description: p.description,
                applicationId: app.id,
                applicationName: app.name,
                applicationIds: [app.id]
              });
            }
          }
        }
      }

      setSelectedCodes(normalized);
      setSelectedCodesSend({
        profiles: normalized.map(({ profileId, description, applicationId }) => ({
          Id: profileId,
          Description: description,
          ApplicationId: applicationId
        })),
        employeeId: selectedEmployeeId,
        action: 'MODIFICAR'
      });

      setLoadingProfiles(false); // <-- TERMINA CARGA
    }
  };

  normalizeProfilesWithApplications();
}, [applications, data?.profiles, isDataReadOnly]);


  useEffect(() => {
    const fetchProfiles = async () => {
      if (selectedApplicationId) {
        const filtered = await getProfilesByApplication(selectedApplicationId, companyId);
        setFilteredProfiles(filtered);
        setPerfilId(''); // limpia selección anterior
        setSelectedCode(null);
      } else {
        setFilteredProfiles([]);
      }
    };

    fetchProfiles();
  }, [selectedApplicationId]);



const handleAddprofiles = (e, profileOverride) => {
  e.stopPropagation();

  const profile = profileOverride || selectedCode;
  if (!profile) return;

  const application = applications.find(a => a.id === selectedApplicationId);
  if (!application) return;

  // Cada par perfil+aplicación es único
  const alreadyExists = selectedCodes.some(
    el => el.profileId === profile.id && el.applicationId === application.id
  );

  if (alreadyExists) return;

  const newProfile = {
    id: `${profile.id}-${application.id}`,
    profileId: profile.id,
    description: profile.description,
    applicationId: application.id,
    applicationName: application.name,
    applicationIds: [application.id]
  };

  const updatedProfiles = [...selectedCodes, newProfile];

  setSelectedCodes(updatedProfiles);
  setIsDirty(true);
  setExpandedGroups(prev => new Set([...prev, application.name]));

  setSelectedCodesSend({
    ...selectedCodesSend,
    profiles: updatedProfiles.map(({ profileId, description, applicationId }) => ({
      Id: profileId,
      Description: description,
      ApplicationId: applicationId
    })),
    employeeId: selectedEmployeeId,
    action: action === ACTIONS.NEW ? 'CREAR' : 'MODIFICAR'
  });
};





const handleSelectedAirport = async (e) => {
    e.stopPropagation();

    setSelectedAirport(e.target.value);

    await loadEmployeesByAirport(e.target.value);

    if (userId === 0) {
        setEmployeeSelected(null);
        user.identification = '';
        user.airportId = 0;
        user.fullName = '';
        user.active = true;
        user.position = '';
        user.onboardingDate = '';
        user.birthDate = '';
        setChanges({ Base: false, Picture: false });
    } else {
        changes.Base = true;
        setChanges(changes);
    }
}

async function loadEmployeesByAirport(AirportId) {
    const employeesData = isDataReadOnly
        ? await getallemployeesByAirportForEdit(AirportId, companyId)
        : await getallemployeesByAirport(AirportId, companyId);

    setEmployees(employeesData);
    return employeesData;
}

const onSave = () => {
  // En modo edición, si el empleado no se encontró en la compañía activa
  // usamos el employeeId original que llegó como prop
  const resolvedEmployeeId = employeeSelected?.employeeId || (isDataReadOnly ? selectedEmployeeId : null);

  if (!resolvedEmployeeId || selectedCodes.length === 0 || (!isDataReadOnly && !selectedAirport)) {
    enqueueSnackbar('Debe ingresar todos los datos', { variant: 'error' });
    return;
  }

  const newSelectedCodesSend = {
    profiles: selectedCodes.flatMap(({ profileId, description, applicationIds }) =>
      applicationIds.map(appId => ({
        Id: profileId,
        Description: description,
        ApplicationId: appId
      }))
    ),
    employeeId: resolvedEmployeeId,
    action: isDataReadOnly ? 'MODIFICAR' : 'CREAR'
  };


  // Llamar a handleSave con el nuevo objeto selectedCodesSend
  handleSave(newSelectedCodesSend);
  
};

  const handleDelete = (e, cellValues) => {
    e.stopPropagation();
    const updatedSelectedCodes = selectedCodes.filter(el => el.id !== cellValues.row.id);
    // Aquí debes actualizar el estado con una función callback para asegurarte de que estás utilizando el estado más reciente.
    setSelectedCodes(updatedSelectedCodes);
  };


  return (
    <div   >
      <Dialog
        maxWidth="md"
        fullWidth="md"
        open={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ pb: 1 }}>
          <Typography variant="h6" fontWeight="bold" style={{ color: '#1a3072' }}>
            Perfiles Adicionales Por <span style={{ color: '#00b0ef' }}>Empleado</span>
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 2, p: 2, bgcolor: '#f5f7fa', borderRadius: 2, border: '1px solid #e0e4ed' }}>
            <Typography variant="subtitle2" sx={{ mb: 1.5, color: '#1a3072', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: 1 }}>
              Datos del Empleado
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  size="small"
                  disableClearable
                  options={[{ id: 0, code: 'Todas' }, ...airports]}
                  getOptionLabel={(o) => o.code || ''}
                  isOptionEqualToValue={(o, v) => o.id === v.id}
                  value={[{ id: 0, code: 'Todas' }, ...airports].find(a => a.id === selectedAirport) || null}
                  onChange={(_, newValue) => {
                    handleSelectedAirport({ target: { value: newValue?.id ?? 0 }, stopPropagation: () => {} });
                  }}
                  disabled={isDataReadOnly}
                  renderInput={(params) => <TextField {...params} label="Base" size="small" />}
                  noOptionsText="Sin resultados"
                />
              </Grid>
              <Grid item xs={12} sm={9}>
                <Autocomplete
                  noOptionsText={'Sin resultados'}
                  disablePortal
                  size='small'
                  options={employees}
                  getOptionLabel={(option) => option ? `${option.employeeId} - ${option.name} ${option.lastName}` : ''}
                  value={employeeSelected}
                  onChange={(event, newValue) => { setEmployeeSelected(newValue); setIsDirty(true); }}
                  disabled={isDataReadOnly}
                  renderInput={(params) => <TextField {...params} label="Empleado" />}
                />
              </Grid>
              {employeeSelected?.employeePosition?.name && (
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 0.5 }}>
                    <Typography variant="caption" sx={{ color: '#888', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                      Cargo:
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#1a3072', fontWeight: 500 }}>
                      {employeeSelected.employeePosition.name}
                    </Typography>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>

          <Typography variant="subtitle2" sx={{ mb: 1, color: '#1a3072', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: 1 }}>
            Asignación de Perfiles
          </Typography>

         <Grid container spacing={2}>
            {/* Aplicación con Autocomplete */}
            <Grid item xs={11} sm={6}>
              <FormControl fullWidth margin="dense">
                <Autocomplete
                  id="autocomplete-application"
                  options={applications}
                  getOptionLabel={(option) => option.name || ''}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  value={applications.find(a => a.id === selectedApplicationId) || null}
                  onChange={(event, newValue) => {
                    setSelectedApplicationId(newValue ? newValue.id : '');
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Aplicación" variant="outlined" size="small" />
                  )}
                  noOptionsText="Sin resultados"
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth margin="dense">
                <Autocomplete
                  id="autocomplete-profile"
                  options={filteredProfiles}
                  getOptionLabel={(option) => option.description || ''}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  value={selectedCode}
                  onChange={(event, newValue) => {
                    setSelectedCode(newValue || null);
                    setPerfilId(newValue ? newValue.id : '');
                    if (newValue) handleAddprofiles({ stopPropagation: () => {} }, newValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Perfil" variant="outlined" size="small" />
                  )}
                  noOptionsText="Seleccione una aplicación primero"
                />
              </FormControl>
            </Grid>
          </Grid>
            <p />
           {loadingProfiles ? (
              <Box display="flex" justifyContent="center" alignItems="center" height={200}>
                <CircularProgress />
                <Typography variant="body1" sx={{ ml: 2 }}>Cargando perfiles...</Typography>
              </Box>
            ) : selectedCodes.length === 0 ? (
              <Box sx={{ p: 2, textAlign: 'center', color: '#aaa' }}>
                <Typography variant="body2">Sin perfiles asignados</Typography>
              </Box>
            ) : (
              <Box sx={{ maxHeight: 320, overflowY: 'auto', pr: 0.5 }}>
                {Object.entries(
                  selectedCodes.reduce((groups, item) => {
                    const appName = item.applicationName || 'Sin aplicación';
                    if (!groups[appName]) groups[appName] = [];
                    groups[appName].push(item);
                    return groups;
                  }, {})
                ).map(([appName, profiles]) => (
                  <Accordion key={appName} expanded={expandedGroups.has(appName)} disableGutters elevation={0}
                    onChange={(_, isExpanded) => setExpandedGroups(prev => { const next = new Set(prev); isExpanded ? next.add(appName) : next.delete(appName); return next; })}
                    sx={{ border: '1px solid #e0e4ed', borderRadius: '8px !important', mb: 1, '&:before': { display: 'none' } }}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                      sx={{ bgcolor: '#f0f4ff', borderRadius: '8px', minHeight: 40, '& .MuiAccordionSummary-content': { my: 0.5 } }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', pr: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="caption" sx={{ color: '#1a3072', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 0.8 }}>
                            {appName}
                          </Typography>
                          <Chip label={profiles.length} size="small" sx={{ height: 18, fontSize: '0.65rem', bgcolor: '#1a3072', color: '#fff' }} />
                        </Box>
                        <Chip
                          icon={<DeleteSweepIcon sx={{ fontSize: '14px !important' }} />}
                          label="Quitar todo"
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            const ids = new Set(profiles.map(p => p.id));
                            setSelectedCodes(prev => prev.filter(el => !ids.has(el.id)));
                            setIsDirty(true);
                          }}
                          sx={{ height: 20, fontSize: '0.65rem', bgcolor: '#fef2f2', color: '#e53935', border: '1px solid #fecaca', '& .MuiChip-icon': { color: '#e53935' }, '&:hover': { bgcolor: '#fee2e2' } }}
                        />
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{ pt: 1, pb: 1.5 }}>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {profiles.map(p => (
                          <Chip
                            key={p.id}
                            label={p.description}
                            size="small"
                            onDelete={() => { setSelectedCodes(prev => prev.filter(el => el.id !== p.id)); setIsDirty(true); }}
                            sx={{ bgcolor: '#e8f0fe', color: '#1a3072', fontWeight: 500, '& .MuiChip-deleteIcon': { color: '#e53935' } }}
                          />
                        ))}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Box>
            )}
        </DialogContent>
        <DialogActions sx={{ m: 1 }}>
          <Box>
            <Button color="primary" variant="contained" onClick={onSave} endIcon={<SaveIcon />}>
              {ACTIONS.SAVE}
            </Button>
          </Box>
          <Box sx={{ m: 1, position: 'relative' }}>
            <Button
              endIcon={<CancelIcon />}
              variant="outlined"
              onClick={() => isDirty ? setShowCancelAlert(true) : handleClose()}
            >{ACTIONS.CANCEL}</Button>
          </Box>
        </DialogActions>
      </Dialog>

      <Dialog open={showCancelAlert} maxWidth="xs" fullWidth onClose={() => setShowCancelAlert(false)}>
        <DialogContent sx={{ textAlign: 'center', pt: 4, pb: 2 }}>
          <WarningAmberRoundedIcon sx={{ fontSize: 56, color: '#f59e0b', mb: 1.5 }} />
          <Typography variant="h6" fontWeight="bold" sx={{ color: '#1a3072', mb: 1 }}>
            ¿Descartar cambios?
          </Typography>
          <Typography variant="body2" sx={{ color: '#666' }}>
            Tiene cambios sin guardar. Si sale ahora, se perderán todos los cambios realizados.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', gap: 1, pb: 3 }}>
          <Button
            variant="outlined"
            onClick={() => setShowCancelAlert(false)}
            sx={{ minWidth: 140, borderColor: '#1a3072', color: '#1a3072', '&:hover': { borderColor: '#1a3072', bgcolor: '#f0f4ff' } }}
          >
            Seguir editando
          </Button>
          <Button
            variant="contained"
            onClick={() => { setShowCancelAlert(false); handleClose(); }}
            sx={{ minWidth: 140, bgcolor: '#e53935', '&:hover': { bgcolor: '#b71c1c' } }}
          >
            Salir sin guardar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ManagementEmployeeDetail;